import { render } from "./HotkeysHandler.vue?vue&type=template&id=2d0e81de&ts=true"
import script from "./HotkeysHandler.vue?vue&type=script&lang=ts"
export * from "./HotkeysHandler.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__